"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsHandler = void 0;
const uuid_1 = require("uuid");
const Types_1 = require("../../Types");
const version_1 = require("../../version");
class OptionsHandler {
    constructor(appInfo) {
        this.setAllInfo = (appInfo) => {
            this.appVersion = appInfo.appVersion;
            this.deviceUUID = appInfo.deviceUUID;
            this.hardwareId = appInfo.hardwareId;
            this.userAgent = appInfo.userAgent;
            this.appCode = appInfo.appCode || Types_1.AppCode.NODE;
            this.instanceId = appInfo.instanceId || (0, uuid_1.v4)();
            this.releaseChannel = appInfo.releaseChannel || Types_1.ReleaseChannel.DEV;
        };
        this.getCompiledUserAgent = () => {
            if (!this.areAllFieldsFulfilled()) {
                throw new Error("All app info fields must be present");
            }
            return `${this.userAgent} DeakoUserAgent/${Types_1.DeakoUserAgentVersion.VERSION_1}`
                + ` Humboldt/${OptionsHandler.humboldtVersion} ${this.appCode}/${this.appVersion} (${this.releaseChannel})`;
        };
        this.getCompiledDeakoDeviceHeader = () => {
            if (!this.areAllFieldsFulfilled()) {
                throw new Error("All app info fields must be present");
            }
            return `${this.hardwareId} ${this.deviceUUID} ${this.instanceId}`;
        };
        this.clearAllInfo = () => {
            this.appCode = undefined;
            this.appVersion = undefined;
            this.deviceUUID = undefined;
            this.hardwareId = undefined;
            this.instanceId = undefined;
            this.releaseChannel = undefined;
            this.userAgent = undefined;
        };
        this.areAllFieldsFulfilled = () => !!(this.appCode
            && this.appVersion
            && this.deviceUUID
            && this.hardwareId
            && this.instanceId
            && this.releaseChannel
            && this.userAgent);
        if (OptionsHandler.instance) {
            return OptionsHandler.instance;
        }
        OptionsHandler.humboldtVersion = (0, version_1.getHumboldtVersion)();
        this.setAllInfo(appInfo);
        OptionsHandler.instance = this;
    }
}
exports.OptionsHandler = OptionsHandler;
//# sourceMappingURL=OptionsHandler.js.map